<template>
  <div class="scenicParkDetail">
    <loading v-if="isLoading"></loading>
    <div v-else>
      <div v-if="!isPageError">
        <div class="banner_container">
          <van-swipe :autoplay="5000" :loop="true" :show-indicators="true" @change="swiperChange('img',$event)">
            <div slot="indicator" class="indicator_box">
              {{imgIndex + 1}} / {{detailData.imageList.length}}
            </div>
            <van-swipe-item v-for="(item,index) in detailData.imageList" :key="index">
              <van-image width="100%" :src="item"></van-image>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="desc_container">
          <div class="desc_box">
            <div class="desc_left">
              <div class="desc_title">{{detailData.title}}</div>
              <div class="desc_distance">
                <span v-if="isShowDistance">距你{{distance(detailData.latitude,detailData.longitude)}}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                <span>{{detailData.sourceScenicName}}</span>
              </div>
              <div class="desc_label_box">
                <div class="desc_label" v-for="(item,index) in detailData.tags" :key="index">{{item}}</div>
              </div>
            </div>
            <div class="desc_right">
              <div class="right_bottom">
                <div class="bottom_item" @click="goToLocation(detailData)">
                  <img src="../../assets/img/goHere_icon.png" alt="">
                  <div class="item_text">去这里</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="intro_container">
          <div class="intro_title">摄影点概况</div>
          <div class="intro_innerText">{{detailData.brief}}</div>
          <!-- <div class="intro_innerText" :class="{intro_innerText_hidden:foldState}">{{detailData.brief}}</div>
          <div class="intro_fold" @click="changeFoldState">
            <div>{{foldState?'展开':'收起'}}</div>
            <img :style="{transform:foldState?'':'rotate(180deg)'}" src="../../assets/img/fold_icon.png" alt="">
          </div> -->
        </div>

        <!-- 用户评论 -->
        <div class="comment-box">
          <van-cell v-if="CommentNum" title="精彩点评" is-link :value="'全部 '+CommentNum + ' 条点评'" @click="AllDiscussList()" />
          <van-cell v-else title="精彩点评" />
          <div class="comment-list" v-if="CommentNum !== 0">
            <customListView :arraydata="commentList" @itemDianZan="itemDianZan" @itemClick="Details" @bigPictureLook="BigPictureLook" @itemReply="itemReply">
            </customListView>
          </div>
          <div class="list-no" v-if="CommentNum === 0">
            <p>来发表第一条评论吧~</p>
          </div>
          <div class="btn">
            <van-button color="#2EBA73" @click="Write()">
              写点评
            </van-button>
          </div>
        </div>

        <div>
          <writeComment ref="writeComment" @Fb="Fb(arguments)" id="modalId"></writeComment>
        </div>

        <div>
          <displayimage ref="displayimage"></displayimage>
        </div>
        <!-- 用户评论 end -->

      </div>
      <page-error v-else></page-error>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
// import { Empty } from 'vant';
import LeftImg from '@/components/LeftImgRightText';
import PageError from '../../components/PageError';
import Loading from '@/components/loading';
import { getDistance } from '../../common/common';
import writeComment from "@/components/writeComment.vue";
import customListView from "@/components/customListViewComment.vue";
import displayimage from "@/components/displayImage.vue";
import axios from 'axios'

// Vue.use(Empty);
export default {
  name: "line_list",
  data() {
    return {
      isPageError: false,
      isLoading: true,
      // 视频数组
      videoArr: [],
      // 图片数组
      imgList: [],
      CommentNum: 0, // 评论条数
      commentList: [],
      isVideo: false,
      scenicId: '',
      imgIndex: 0,
      videoIndex: 0,
      detailData: {},
      foldState: true,
      //附近推荐
      aroundTabArray: [],
      aroundData: [],
      allATbArr: [],
      aroundTabActive: 0,
      // 收藏数据对象
      collectObj: {},
      isShowDistance: false

    };
  },
  components: {
    // LeftImg,
    Loading,
    PageError,
    writeComment,
    customListView,
    displayimage
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name) {
        window.location.reload();
      }
    }
  },
  mounted() {
    this.uid = this.$cookie.get('w_uid') || '';
    this.scenicId = this.$route.query.id;
    this.lat = this.$route.query.lat;
    this.lng = this.$route.query.lng;
    this.isShowDistance = Boolean(sessionStorage.getItem('isShowDistance'));
    this.getCommentList();
    this.getScenicSpotDetail();
  },
  methods: {


    /**
     * 去导航
     */
    goToLocation(item) {
      item.address = item.address ? item.address : ' ';
      this.openLocation(item.latitude, item.longitude, item.title, item.address);
    },
    /**
     * 轮播图改变事件
     */
    swiperChange(type, event) {
      this.imgIndex = event;
    },
    /**
     * 改变展开/收起状态
     */
    changeFoldState() {
      this.foldState = !this.foldState
    },
    /**
     * 获取摄影店详情数据
     */
    getScenicSpotDetail() {
      this.$request.get(`/appserver/v1/scenic/bestFilm/detail?filmId=${this.scenicId}`).then((res) => {
        if (res.data.ret == 0) {
          let resData = res.data.data;
          this.isLoading = false;
          this.detailData = resData;

        } else {
          this.isLoading = false;
          this.isPageError = true;
        }
      }).catch((e) => {
        console.log(e);
        this.isLoading = false;
        this.isPageError = true;
      });
    },

    /**
       * 跳转至导航页
       */
    toMap(lat, lng, location, address) {
      address = address ? address : ' ';
      this.openLocation(lat, lng, location, address);
    },

    /**
    * 计算距离你多少距离
    * @params lat lng 景区 景点 经纬度
    */
    distance(lat, lng) {
      if (this.$route.query.lat && this.$route.query.lng) {
        let obj = getDistance(lat, lng, this.$route.query.lat, this.$route.query.lng);
        return obj.distance.toFixed(1) + (obj.type == 'km' ? '公里' : '米');
      } else {
        // return { distance: '', text: '' };
        return '0米';
      }
    },
    /**
     * 获取评论
     */
    getCommentList() {
      let fromData = new FormData();
      fromData.append("cid", this.scenicId);
      fromData.append("type", 'bestSpot');
      this.$request.post(`/appserver/v1/comment/list`, fromData)
        .then((data) => {
          let _data = data.data.data;
          if (_data.list.length !== 0) {
            this.commentList = _data.list;
          }
          this.CommentNum = _data.comment_num; // 评论条数
        });
    },

    /**
     * 用户点赞回调 
     */
    itemDianZan(item, commId) {
      if (!this.uid) {
        if (this.$cookie.get('w_uid') == 0) {  // 登录了未绑定手机号
          this.$router.push({
            name: 'bindingPhone',
            query: {
              for: 'other'
            }
          })
        } else {  // 未登录
          this.wxAuth();
        }
        return;
      }
      let data = {
        comment_id: commId,
        number: "1",
      };
      let fromData = new FormData();
      fromData.append('comment_id', commId);
      fromData.append('number', 1);
      this.$request
        .post(`/appserver/v1/comment/deleteOrUp`, fromData, {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          if (data.data.ret === 0) {
            item.up++;
            item.is_up = !item.is_up;
          } else {
            this.$toast(data.data.msg);
          }
        });
    },

    /**
     * 回复
     * @params item 回复的评论item commId  回复的commitId
     */
    itemReply(item, commId) {
      this.parentId = commId;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        this.wxAuth();
      }
    },

    // 用户评论列表
    AllDiscussList() {
      if (this.CommentNum <= 0) {
        return;
      } else {
        this.$router.push({
          path: "/allDiscussList",
          query: {
            cid: this.scenicId,
            type: "bestSpot",
          },
        });
      }
    },
    // 评论详情
    Details(item) {
      this.$router.push({
        path: "/discussDetails",
        query: {
          comment_id: item.comment_id,
          type: "bestSpot",
          from: "web",
        },
      });
    },
    // 图片点击放大
    BigPictureLook(item, index) {
      let imageArr = [];
      for (let i = 0; i < item.length; i++) {
        if (item[i].checkRet == 1) { // 非法图片
          imageArr.push('');
        } else {
          imageArr.push(item[i].data);
        }
      }
      this.$refs.displayimage.showBigPictureLook(imageArr, index);
    },
    // 写评论
    Write() {
      // 确保parentId为空，不是回复操作
      this.parentId = null;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        this.wxAuth();
      }
    },
    // 发表
    Fb(msg) {
      var message = msg[0];
      var gallerysStr = msg[1];
      let fromData = new FormData();
      fromData.append('content', message);
      fromData.append('cid', this.scenicId);
      fromData.append('ctitle', document.title);
      fromData.append('type', 'bestSpot');
      fromData.append('source_type', 'h5');
      fromData.append('image', gallerysStr);
      if (this.parentId) {
        fromData.append('parent_id', this.parentId);
      }
      this.$request
        .post(`/appserver/v1/comment/addComment`, (fromData), {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          console.log(data, 'asdasdasdasd');
          if (data.data.ret == 0) {
            if (this.parentId) {
              this.$toast("回复成功");
            } else {
              this.$toast("发布成功");
            }
            this.getCommentList();
            this.$refs.writeComment.ClosePost();
          } else {
            this.$refs.writeComment.ClosePost();
            if (data.data.msg == 'uid不能为空') {
              this.wxAuth();
            } else {
              this.$toast(data.data.msg);
            }
          }
        });
    },

  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.scenicParkDetail {
  .banner_container {
    position: relative;
    width: 100%;
    min-height: 177px;
    // background: gray;
    .video_ele {
      width: 100%;
      height: 177px;
      object-fit: fill;
    }
    .indicator_box {
      position: absolute;
      bottom: 20px;
      right: 20px;
      color: white;
      padding: 2px 8px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
    }
  }

  .desc_container {
    padding: 10px 20px 30px 20px;
    padding-bottom: 0;
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    .desc_box {
      display: flex;
      justify-content: space-between;
      .desc_left {
        padding-top: 20px;
      }
      .desc_right {
        padding-top: 20px;
        .right_bottom {
          display: flex;
          .bottom_item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-left: 18px;
            margin-top: 10px;
            img {
              width: 32px;
              height: 32px;
              margin-bottom: 4px;
            }
            .item_text {
              font-size: 11px;
              color: rgba(0, 0, 0, 0.5);
              white-space: nowrap;
            }
          }
        }
      }
    }
    .desc_title {
      font-size: 24px;
      color: #262626;
      font-weight: 700;
    }
    .desc_distance {
      margin-top: 6px;
      color: #7f7f7f;
      font-size: 12px;
      letter-spacing: 0.5px;
    }
    .desc_label_box {
      margin-top: 10px;
      padding-bottom: 30px;
      border-bottom: 1px solid rgba(216, 216, 216, 0.3);
      .desc_label {
        padding: 2px 5px;
        background: rgba(97, 69, 247, 0.15);
        color: #6145f7;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }

  .intro_container {
    padding: 30px 20px;
    color: #262626;
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    .intro_title {
      font-size: 20px;
      font-weight: 700;
    }
    .intro_innerText {
      font-size: 14px;
      color: #787878;
      margin-top: 10px;
      line-height: 20px;
      //   width: 200px;
    }
    .intro_innerText_hidden {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //将对象作为弹性伸缩盒子模型显示
      -webkit-line-clamp: 4; //控制显示几行文字
      -webkit-box-orient: vertical; //设置伸缩盒对象的子元素排列方式
    }
    .intro_fold {
      margin-top: 4px;
      font-size: 14px;
      color: #2eba73;
      display: flex;
      align-items: center;
      img {
        width: 11px;
        height: 7px;
        margin-left: 4px;
      }
    }
  }

  // 评论列表 start
  .comment-box {
    padding: 20px;
    border-top: 5px solid rgba(0, 0, 0, 0.05);
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    /deep/ .van-cell {
      margin: 25px 0px;
      padding: 0px;
    }
    /deep/ .van-cell__title span {
      font-size: 20px;
      font-family: PingFangTC-Medium, PingFangTC;
      font-weight: 500;
      color: rgba(55, 56, 77, 1);
    }
    /deep/ .van-cell__value {
      font-size: 15px;
      font-family: PingFangSC-Light, PingFang SC;
      // font-weight: 300;
      color: #000;
    }
    /deep/ .van-cell:not(:last-child)::after {
      border: 0px;
    }
    /deep/ .van-icon {
      color: #37384d;
      font-size: 16px;
    }
    .comment-list {
      padding: 0px;
    }
    .list-no {
      text-align: left;
      // padding: 30px 0px 0px 0px;
      & > p {
        height: 14px;
        font-size: 15px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
      }
    }
    .btn {
      margin-top: 29px;
      width: 100%;
      opacity: 0.95;
      margin-bottom: 24px;
      /deep/ .van-image {
        margin-right: 4px;
        margin-top: -3px;
        img {
          border-radius: 3px;
        }
      }
      /deep/ .van-button {
        width: 100%;
        border: 0px;
        height: 40px;
      }
      /deep/ .van-button span {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        /deep/ .van-icon {
          color: #fff;
          margin-right: 7px;
        }
      }
      /deep/ .van-icon {
        color: #fff;
        margin-right: 7px;
      }
    }
  }
  // 评论列表 end
}
</style>
